// skipcq: JS-W1028
import { useContext } from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import BeerReviewStatsCard from '../../components/brewhouse/BeerReviewStatsCard';
import BrewhousePageShell from '../../components/brewhouse/BrewhousePageShell';
import { BrewerySessionContext } from '../../context/BrewerySessionContext';
import useUserWelcomeName from '../../hooks/useUserWelcomeName';

function BrewhouseDashboardContent() {
  const session = useContext(BrewerySessionContext);
  const { welcomeName } = useUserWelcomeName();

  if (session.isLoading) {
    return (
      <Box sx={{ py: 8, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (session.breweryId === null) {
    return (
      <BrewhousePageShell
        breadcrumbs={[{ label: 'Brewhouse' }]}
        title="Welcome to your Brewhouse"
        maxWidth={560}
      >
        <Card variant="outlined">
          <CardContent>
            <Typography variant="body1" color="text.secondary">
              Complete your brewery claim to see dashboard data. Use Claim in the left
              navigation to get started.
            </Typography>
          </CardContent>
        </Card>
      </BrewhousePageShell>
    );
  }

  const welcomeTitle =
    welcomeName.length > 0 ? `Welcome, ${welcomeName}` : 'Welcome';

  return (
    <BrewhousePageShell
      breadcrumbs={[{ label: 'Brewhouse' }]}
      title={welcomeTitle}
      maxWidth={1200}
    >
      {session.showLocationSelector ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2 }}
          data-testid="dashboard-managing-label"
        >
          {`Managing: ${session.activeScopeLabel || session.activeLocationLabel}`}
        </Typography>
      ) : null}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <BeerReviewStatsCard />
        </Grid>
        <Grid item xs={12} md={4} />
        <Grid item xs={12} md={4} />
      </Grid>
    </BrewhousePageShell>
  );
}

export default function BrewhouseDashboardPage() {
  return <BrewhouseDashboardContent />;
}
